// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm_form__sgi8v","btnContainer":"ContactForm_btnContainer__vMKEU"};